import React from 'react';

type Props = {
    className?: string;
    fillColor?: string;
    width?: number;
    height?: number;
};

const SmartMediaIcon = React.memo(function SmartMediaIcon({
    className,
    fillColor = 'currentColor',
    width = 20,
    height = 20,
}: Props) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.1382 4H4.02765C3.47005 4 2.9927 4.19583 2.59562 4.5875C2.19854 4.97917 2 5.45 2 6V18C2 18.55 2.19854 19.0208 2.59562 19.4125C2.9927 19.8042 3.47005 20 4.02765 20H20.2488C20.8064 20 21.2838 19.8042 21.6809 19.4125C22.078 19.0208 22.2765 18.55 22.2765 18V13H20.2488V18H4.02765V6H12.1382V4ZM9.60369 7.5V16.5L16.7005 12L9.60369 7.5Z"
                fill={fillColor}
            />
            <path
                d="M21.4011 4.39883L20.9239 3.30709L19.7909 2.80588L20.9239 2.31472L21.4011 1.27325L21.868 2.31365L23 2.80588L21.868 3.30816L21.4011 4.39883ZM21.4011 10.3812L20.9239 9.3296L19.7909 8.83844L20.9239 8.34728L21.4011 7.24549L21.868 8.34621L23 8.83844L21.868 9.33067L21.4011 10.3812ZM17.0001 8.86686L16.022 6.77925L13.8921 5.82216L16.022 4.86506L17.0001 2.78751L17.9866 4.86506L20.1025 5.82216L17.9866 6.77925L17.0001 8.86686Z"
                fill={fillColor}
            />
        </svg>
    );
});

export default SmartMediaIcon;
